import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Sitemap from "../../../routes/sitemap";
import AuthContext from "../../../store/auth-context";
import userImg from "../../../assets/images/icons/profile.png";
import { GlobalQueries } from "hooks/useRefreshQuery";
import { useQuery } from "react-query";
import useAPI from "hooks/useAPI";
import axios from "axios";
import scss from "./LeftSideBar.module.scss";
import CategoriesModal from "../MobileDialogs/CategoriesModal/CategoriesModal";
import UserPanelModal from "../MobileDialogs/UserPanelModal/UserPanelModal";
import icons from "helpers/icons";
import SearchModal from "../MobileDialogs/SearchModal/SearchModal";
import DeleteDialog from "components/Dialogs/DeleteDielog";
import { useTranslation } from "react-i18next";

/**
 * Left side navigation.
 */
const LeftSideBar = ({ openModal, setOpenModal }) => {
    const staticAppVersion = "1.0.0";

    const { t, i18n } = useTranslation();

    const api = useAPI();
    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const { pathname } = useLocation();

    /** Log the user out and show login form. */
    const logOut = () => {
        const defaultLanguage = localStorage.getItem("defaultLanguage");
        localStorage.setItem("selectedLanguage", defaultLanguage);
        i18n.changeLanguage(defaultLanguage);
        logout();
        navigate(Sitemap.auth.login);
    };

    // Load all notifications
    const { data: notifications } = useQuery([GlobalQueries.Notifications], () => api.list(`/notifications`));
    const unreadNotificationCount = notifications?.items?.filter((notification) => !notification.seen_date).length;

    // Get the class for the icon in the menu
    const iconClass = (icon) => scss.link + (icon.isActive ? " " + scss.active : "");

    const [openCategoriesModal, setOpenCategoriesModal] = useState(false);
    const [openUserModal, setOpenUserModal] = useState(false);
    const [openSearchModal, setOpenSearchModal] = useState(false);
    const [showDialog, setShowDialog] = useState(false);

    const closeAllModals = () => {
        setOpenCategoriesModal(false);
        setOpenUserModal(false);
        setOpenSearchModal(false);
    };

    const toggleUserPanel = () => {
        setOpenModal("sidebar");
        closeAllModals();
        setOpenUserModal(!openUserModal);
    };

    const toggleSearch = () => {
        setOpenModal("sidebar");
        closeAllModals();
        setOpenSearchModal(!openSearchModal);
    };

    const toggleCategories = () => {
        setOpenModal("sidebar");
        closeAllModals();
        setOpenCategoriesModal(!openCategoriesModal);
    };

    useEffect(() => {
        if (openModal !== "sidebar") {
            closeAllModals();
        }
    }, [openModal]);

    useEffect(() => {
        closeAllModals();
    }, [pathname]);

    const links = [
        { icon: icons.catalogue, label: "global-left_side_bar-nav_list-home", to: Sitemap.home, badge: null },
        {
            icon: icons.notifications,
            label: "global-left_side_bar-nav_list-notifications",
            to: Sitemap.notifications._,
            badge: unreadNotificationCount > 0 && <em className={scss.badge}>{unreadNotificationCount}</em>,
        },
        { icon: icons.cart, label: "global-left_side_bar-nav_list-purchase", to: Sitemap.orders._, badge: null },
        { icon: icons.analytics, label: "global-left_side_bar-nav_list-analytical", to: Sitemap.static.analyticCard, badge: null },
        { icon: icons.contact, label: "global-left_side_bar-nav_list-contact", to: Sitemap.contact._, badge: null },
    ];

    return (
        <>
            <div className={`${scss.wrapper} ${scss.navDesktop}`}>
                <div className={scss.links}>
                    {links.map((link, index) => (
                        <NavLink to={link.to} key={index} className={iconClass} title={t(link.label)}>
                            <img src={link.icon} alt="" />
                            {link.badge}
                        </NavLink>
                    ))}
                </div>

                <div className={scss.links}>
                    <NavLink to={Sitemap.profile._} className={iconClass} title={t("global-left_side_bar-nav_list-profile")}>
                        <img src={userImg} alt="" />
                    </NavLink>
                    <div className={scss.link} onClick={() => setShowDialog(true)} title={t("global-left_side_bar-nav_list-logout")}>
                        <img src={icons.logout} alt="" />
                    </div>
                    <div className="sidebar-footer-line">
                        <p style={{ fontWeight: "100", bottom: "6px", left: "16px", fontSize: "13px", color: "#fff" }}>
                            {process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : staticAppVersion}
                        </p>
                    </div>
                </div>
            </div>
            <div className={`${scss.wrapper} ${scss.navMobile}`}>
                <div className={scss.links}>
                    <div className={`${scss.link} ${scss.active}`} onClick={() => logOut()} title={t("global-left_side_bar-nav_list-logout")}>
                        <img src={icons.logout} alt="" />
                    </div>
                    <Link to={`/nalog`} onClick={toggleUserPanel} className={`${scss.link} `} title={t("global-left_side_bar-nav_list-profile")}>
                        <img src={icons.user_profile} alt="" />
                    </Link>
                </div>
                <div className={scss.links}>
                    <div onClick={toggleSearch} className={`${scss.link} `} title={"Pretraga"}>
                        <img src={icons.search} alt="" />
                    </div>
                    <div onClick={toggleCategories} className={`${scss.link} ${scss.active}`} title={t("global-left_side_bar-nav_list-catalog")}>
                        <img src={icons.catalogue} alt="" /> <span style={{ textDecoration: "uppercase" }}>{t("global-left_side_bar-nav_list-products")}</span>
                    </div>
                    <div className="sidebar-footer-line">
                        <p style={{ fontWeight: "100", bottom: "6px", left: "16px", fontSize: "13px", color: "#fff" }}>
                            {process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : staticAppVersion}
                        </p>
                    </div>
                </div>
            </div>

            <CategoriesModal openModal={openCategoriesModal} setOpenModal={setOpenCategoriesModal} />
            {/*<UserPanelModal openModal={openUserModal} setOpenModal={setOpenUserModal} />*/}
            <SearchModal openModal={openSearchModal} setOpenModal={setOpenSearchModal} />
            <DeleteDialog
                openDeleteDialog={{ show: showDialog }}
                setOpenDeleteDialog={() => setShowDialog(false)}
                handleConfirm={() => {
                    logOut();
                    setShowDialog(false);
                }}
                title={"global-left_side_bar-delete_dialog-title"}
                description={"global-left_side_bar-delete_dialog-description"}
                nameOfButtonDelete={"global-left_side_bar-delete_dialog-button"}
                deafultIcon={false}
            />
        </>
    );
};

export default LeftSideBar;
